module.exports = __webpack_public_path__ + "img/5.f08521b9.png";